import React from 'react';
import ContentRenderer from '../../components/common/ContentRenderer';
import privacyPolicyData from '../../data/privacyPolicy.json';
import { ContentDocument } from '../../types/contentTypes';

interface PrivacyPolicyProps {}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = () => {
  return (
    <ContentRenderer 
      data={privacyPolicyData as ContentDocument}
      contactEmail="admin@thesampark.com"
      showContactInfo={true}
      headerAlignment="center"
      maxWidth="lg"
      showLogo={true}
      logoSrc="/images/sampark-logo.png"
      logoAlt="Sampark Logo"
    />
  );
};

export default PrivacyPolicy;